import {
    type MutationFunctionContext,
    type UseMutationOptions,
    useMutation,
    useQueryClient,
} from "@tanstack/react-query";
import { api } from "api";

type ProviderSettingsPracticeBillPayOptions = UseMutationOptions<string>;

/**
 * Client hook to set Provider's bill pay link.
 * @param options Options for the client call; provides callbacks for when the API call succeeds or fails.
 * @returns React Query mutation properties.
 */
export function useSetProviderSettingsPracticeBillPay(options?: ProviderSettingsPracticeBillPayOptions) {
    const queryClient = useQueryClient();

    /** Provide built-in onSuccess behavior, then call provided callback if available. */
    const onSuccess = (data: string, _: unknown, onMutateResult: unknown, context: MutationFunctionContext) => {
        // Invalidate queries that are affected
        void queryClient.invalidateQueries({
            queryKey: ["providerSettingsPractice"],
        });

        // Use callback if provided
        options?.onSuccess?.(data, undefined, onMutateResult, context);
    };

    return useMutation({
        ...options,
        mutationFn: async () => await api.provider.setPracticeBillPayLink(),
        onSuccess,
    });
}
